<h1 mat-dialog-title>
  <app-draggable-dialog-handle/>
  <span>
    Moving
    <strong>{{ data.equipment.length }}</strong> items to another purchase order
  </span>
</h1>

<div class="dense-1" mat-dialog-content>
  <h5>You can only move equipment to a different draft purchase order.</h5>

  <app-equipment-condense-table [equipment]="data.equipment"></app-equipment-condense-table>
  <form (ngSubmit)="onSubmit()" [formGroup]="moveToForm" class="add-edit-equipment-form">

    <mat-autocomplete #purchaseOrderAuto="matAutocomplete" (optionSelected)="purchaseOrderAutocompleteSelect($event)"
                      class="purchase-order-autocomplete" panelWidth="440px">
      <mat-option *ngFor="let po of filteredPurchaseOrders" [id]="po.id" [value]="po">
        <span class="main-text">
            {{ po.manufacturerNames }}
          </span>
        <span class="hint po-name">{{ po.name }}</span>
        <span class="hint po-status">
            {{ po.status | readable }}
          </span>
      </mat-option>
    </mat-autocomplete>

    <div>
      <mat-form-field class="project">
        <mat-label>Purchase Order</mat-label>
        <input #filter [matAutocomplete]="purchaseOrderAuto" formControlName="purchaseOrderId" matInput
               placeholder="Ex. SONUS-202509"
               type="text">
        <!--   <mat-spinner *ngIf="filterLoading" class="progress-spinner" diameter="24" matSuffix></mat-spinner>
           <button (click)="clearFilter()" aria-label="Clear" mat-icon-button matSuffix>
             <mat-icon *ngIf="!filterLoading"
                       [class.empty]="isFilterEmpty()">close
             </mat-icon>
           </button>-->
        <mat-error *ngIf="moveToForm.controls.purchaseOrderId.hasError('purchaseOrderAutocompleted')">
          You must select a project from autocomplete dropdown.
        </mat-error>
      </mat-form-field>
    </div>

  </form>
</div>
<div mat-dialog-actions>
  <button (click)="onCancelClick()" [color]="moveToForm.dirty ? 'warn' : ''" mat-button>Cancel</button>
  <button (click)="onPrimaryClick()" [disabled]="!moveToForm.valid" color="primary" mat-raised-button>Move</button>
  <mat-error *ngIf="apiError" class="api-error">
    {{ apiError }}
  </mat-error>
</div>
